import React, { ReactNode, createContext } from 'react';
import { useChannelUsers } from '@shared/util/hooks';

interface WorkflowTemplateData {
  users: MBAPI.ShortUser[];
}

interface Props {
  channelId?: number;
  children: ReactNode;
}

export const WorkflowTemplateDataContext = createContext<WorkflowTemplateData>({
  users: [],
});

export function WorkflowTemplateDataProvider({ channelId, children }: Props) {
  const { users } = useChannelUsers({ channelId });
  return (
    <WorkflowTemplateDataContext.Provider value={{ users }}>
      {children}
    </WorkflowTemplateDataContext.Provider>
  );
}
